import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { FormGroup } from '@angular/forms';
import { State } from '../../interfaces/states.model';


export class AddressListener {

  constructor(private catalogService: CatalogsService) { }

  async requestAddress(CP: string, states: State[]) {

    //Pedimos los datos del CP
    const respCp = await firstValueFrom(this.catalogService.getZipCode(CP));
    const colonies = respCp.resultados;


    if (colonies.length === 0) throw new Error('CP no existe');
    //Extraemos idState para extraer los municipios
    let idState = +colonies[0].idState!;

    const dmnpio = colonies[0].dciudad ? colonies[0].dciudad : colonies[0].dmnpio;
    const municipalityName = colonies[0].dmnpio!;

    //Pedimos los municipios y seteamos el cityId ( que es el id del municipio )
    const respMun = await firstValueFrom(this.catalogService.getCities(idState));

    const cityId = +colonies[0].idCity!;

    return {
      municipalities: respMun.cities,
      colonies,
      cityId,
      dmnpio,
      idState,
      municipalityName
    }

  }

  resetForm(form: FormGroup, fields: string[]) {

    form.get(fields[0])!.setValue(1);

    for (const field of fields.slice(1)) {
      form.get(field)!.setValue('');
    }

  }


}
